import { render, staticRenderFns } from "./ReKanban.vue?vue&type=template&id=bac64bc4"
import script from "./ReKanban.vue?vue&type=script&lang=js"
export * from "./ReKanban.vue?vue&type=script&lang=js"
import style0 from "./ReKanban.vue?vue&type=style&index=0&id=bac64bc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports